import { render, staticRenderFns } from "./normalmsg.vue?vue&type=template&id=ecaf9402&scoped=true&"
import script from "./normalmsg.vue?vue&type=script&lang=js&"
export * from "./normalmsg.vue?vue&type=script&lang=js&"
import style0 from "./normalmsg.vue?vue&type=style&index=0&id=ecaf9402&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaf9402",
  null
  
)

export default component.exports